import Vue from 'vue';
import {
  DatePicker,
  Button,
  Dialog,
  Switch,
  Loading,
  RadioGroup,
  RadioButton,
  Select,
  Option,
  MessageBox,
  Message,
  Menu,
  MenuItem,
  Submenu,
  MenuItemGroup,
  Pagination,
  Tag,
  Tooltip,
  Upload,
  Table,
  TableColumn
} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/es';
import locale from 'element-ui/lib/locale';

locale.use(lang);

Vue.use(Loading.directive);

Vue.use(DatePicker);
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Switch);
Vue.use(RadioButton);
Vue.use(RadioGroup);
Vue.use(Select);
Vue.use(Option);
Vue.use(Menu);
Vue.use(MenuItem);
Vue.use(MenuItemGroup);
Vue.use(Submenu);
Vue.use(Pagination);
Vue.use(Tag);
Vue.use(Tooltip);
Vue.use(Upload);
Vue.use(Table);
Vue.use(TableColumn);

Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
